import type { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './FooterLayout.module.css';

interface FooterLinksListProps {
  children: ReactNode;
  className?: string;
  direction?: 'row' | 'column';
  'aria-label'?: string;
}

/** A list component for organizing links */
export function FooterLinksList({
  children,
  className,
  direction = 'column',
  'aria-label': ariaLabel,
}: FooterLinksListProps) {
  return (
    <ul
      aria-label={ariaLabel}
      className={classNames(styles.linksList, className, {
        [styles.row]: direction === 'row',
        [styles.column]: direction === 'column',
      })}
    >
      {children}
    </ul>
  );
}
